module.exports = __webpack_public_path__ + "static/media/dailyRoutine_3_zh_HK.efff772c.png";